import { ButtonColor } from "@/common/enum/button-color";
import { Button, Table } from "flowbite-react";
import React from "react";

interface Props {
  headersLength: number;
  onClickOpenModal: () => void;
}

export const PackageItemChildTableFooter: React.FC<Props> = ({
  headersLength,
  onClickOpenModal,
}) => {
  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex justify-between items-center h-[70px] p-[16px]">
          <div>
            <Button
              size="sm"
              color={ButtonColor.PRIMARY}
              onClick={onClickOpenModal}
            >
              상품 추가하기
            </Button>
          </div>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
